
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { delGcashMultipleAccount, delGcashAccount } from '@/api/gcash/account'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'addAccount',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) list!: any

  get language () {
    return AppModule.language
  }

  private loading: boolean = false
  private back() {
    this.$emit('close')
  }

  private create() {
    this.back()
  }

  // 删除多个

  mounted() {}
}
